import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import VehicleHireDocketForm from './VehicleHireDocketForm';
import { EditMode } from "../../../enums/EditMode";
const VehicleHireDocketPage = () => {
    const navigate = useNavigate();
    const params = useParams();
    const back = () => {
        navigate(`/app/vehicle-hires/edit/${params.vehicleHireId}`);
    };
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article", children: [_jsxs("h2", { className: "article-title", children: [params.docketId === "add" ? "Add" : "Edit", " Docket", _jsx(Button, { className: "pull-right hmargin-sm", onClick: back, children: "Back" })] }), _jsx(VehicleHireDocketForm, { mode: params.docketId === "add" ? EditMode.CREATE : EditMode.EDIT, docketId: params.docketId === "add" ? undefined : Number(params.docketId), vehicleHireId: Number(params.vehicleHireId) })] }) }));
};
export default VehicleHireDocketPage;
